import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/seo/bg.png'
import bg2 from '../../assets/images/bg/bg-lines-two.png'
import hero from '../../assets/images/seo/hero.png'
import seo from '../../assets/images/seo/seo.png'
import searchSvg from '../../assets/images/svg/search.svg'
import searchTwo from '../../assets/images/svg/search-two.svg'

import Navbar from "../../components/navbar";
import CompanyLogo from "../../components/companyLogo";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import FooterTopTwo from "../../components/footerTopTwo";

import { GoRocket, FiArrowRight, MdOutlineCheckCircle } from '../../assets/icons/icons'
 
import { expertiseData, seoBlog } from "../../data/data";

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function IndexSeoAgency(){
    let settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
        responsive: {
            992: {
                items: 5
            },

            767: {
                items: 2
            },
            

            320: {
                items: 1
            },
        },
      };
    return(
        <>
        <Navbar navLight={true}/>
        <section className="bg-home bg-primary d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center', height:'auto'}} id="home">
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-lg-12 text-center mt-0 mt-md-5 pt-0 pt-md-5">
                        <div className="heading-title margin-top-100">
                            <GoRocket className="h1 text-white-50"/>
                            <h1 className="display-4 fw-bold text-white title-dark my-3">We are full service SEO agency</h1>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="subcribe-form mt-4 pt-2">
                                <form>
                                    <div className="mb-3">
                                        <input type="url" id="url" className="border bg-white rounded-lg" style={{opacity: '0.85'}} required placeholder="http://shreethemes.in"/>
                                        <button type="submit" className="btn btn-pills btn-primary">Get Started</button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10">
                                <div className="home-dashboard">
                                    <img src={hero} alt="" style={{top: '0'}} className="img-fluid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape seo-hero overflow-hidden text-light"></div>
        </div>

        <section className="pt-5">
            <div className="container">
                <CompanyLogo/>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Discover our expertise <br/> that you need</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {expertiseData.map((item, index) =>{
                        let Icon = item.icon
                        return(
                        <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                            <div className="card border-0 features feature-primary rounded">
                                <div className="icon text-center rounded-md">
                                    <h3 className="mb-0"><Icon/></h3>
                                </div>
    
                                <div className="card-body p-0 mt-4">
                                    <h5>{item.title}</h5>
                                    <p className="text-muted mb-0">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                    <div className="col-12 mt-5 pt-2">
                        <Link to="" className="text-primary h6 mb-0">Explore all features <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-primary" style={{backgroundImage:`url(${bg2})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="section-title">
                            <h4 className="title text-white title-dark mb-4">Everything you need</h4>
                            <p className="text-white-50 para-desc mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>

                        <div className="mt-4 pt-2">
                            <h6 className="text-white title-dark">Ability to customize Title Tags</h6>
                            <p className="text-white-50 para-desc mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>

                        <div className="mt-4 pt-2">
                            <h6 className="text-white title-dark">A well-optimized URL structure</h6>
                            <p className="text-white-50 para-desc mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>

                        <div className="mt-4 pt-2">
                            <h6 className="text-white title-dark">Good customer support system.</h6>
                            <p className="text-white-50 para-desc mb-0">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <img src={seo} className="img-fluid" alt=""/>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-5">
                        <img src={searchSvg} alt=""/>
                    </div>

                    <div className="col-lg-6 col-md-7">
                        <div className="section-title">
                            <h1 className="title mb-3">We help you increase <br/> sales by improving SEO</h1>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-5 order-1 order-md-2">
                        <img src={searchTwo} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-6 col-md-7 order-2 order-md-1">
                        <div className="section-title">
                            <h1 className="title mb-3">Collaborate with your <br/> team anytime, anywhere.</h1>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <span className="badge rounded-pill bg-soft-primary h6">Blog</span>
                            <h4 className="title mt-2 mb-4">Latest News & Blogs</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4 pt-2" id="slider-container">
                <div className="row slider-row-width">
                    <div className="col-12">
                        <div className="swiper-container">
                            <div className="swiper-wrapper">
                                <TinySlider settings={settings}>
                                    {seoBlog.map((item,index) =>{
                                        return(
                                        <div className="swiper-slide" key={index}>
                                            <div className="card border-0 work-container m-3 work-primary work-border shadow overflow-hidden rounded-md">
                                                <div className="card-body p-0">
                                                    <Link to="#"><img src={item.image} className="img-fluid work-image" alt=""/></Link>
                                                    <div className="content text-center p-4">
                                                        <h5 className="mb-0"><Link to="#" className="text-dark title">{item.title}</Link></h5>
                                                        <h6 className="text-muted tag mb-0">{item.name}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    })}
                                </TinySlider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <FooterTopTwo/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}